import { Link } from 'react-router-dom';
import { Linkedin } from 'lucide-react';

const footerLinks = {
  product: [
    { href: '/explore', label: 'Explore Sessions' },
    { href: '/principles', label: 'Principles' },
    { href: '/books', label: 'Books' },
    { href: '/ask', label: 'Ask a Question' },
  ],
  company: [
    { href: '/about', label: 'About' },
    { href: '/contact', label: 'Contact' },
    { href: '/blog', label: 'Blog' },
  ],
  legal: [
    { href: '/privacy', label: 'Privacy Policy' },
    { href: '/terms', label: 'Terms of Service' },
  ],
};

export function Footer() {
  return (
    <footer className="bg-cream-dark border-t border-border">
      <div className="container-wide section-padding">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-display text-xl font-semibold text-foreground">
              AskAjayya
            </Link>
            <p className="mt-4 text-sm text-muted-foreground">
              Real problems. Clear leadership. Actionable guidance for the challenges that matter.
            </p>
            <a
              href="https://www.linkedin.com/in/ajayya-kumar/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              <Linkedin className="h-4 w-4" />
              LinkedIn
            </a>
          </div>

          {/* Product Links */}
          <div>
            <p className="font-semibold text-sm mb-4">Product</p>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <p className="font-semibold text-sm mb-4">Company</p>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <p className="font-semibold text-sm mb-4">Legal</p>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} AskAjayya. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            For educational and leadership reflection only. Not professional advice.
          </p>
          <p className="text-xs text-muted-foreground">
            Built with ❤️ by{' '}
            <a href="https://NextMindDigital.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
              NextMind Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
